import { BrowserAgent } from "@newrelic/browser-agent/loaders/browser-agent";
import { isDevMode } from "src/config/env";

import config from "./newRelicConfig";

let agent: BrowserAgent | null = null;

export const getOrgStructureNRAgent = (): BrowserAgent | null => {
  if (isDevMode()) return null;

  if (!agent) {
    agent = new BrowserAgent(config);
  }

  return agent;
};

getOrgStructureNRAgent();
